const colorPickerName = "TidalColorPicker";
export {
  colorPickerName
};
//# sourceMappingURL=classes.js.map
